import { render, staticRenderFns } from "./ListItemShippingsAmount.vue?vue&type=template&id=08f17226"
import script from "./ListItemShippingsAmount.vue?vue&type=script&lang=js"
export * from "./ListItemShippingsAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports